import { render, staticRenderFns } from "./TheHallbar.vue?vue&type=template&id=5a96fcec&scoped=true"
import script from "./TheHallbar.vue?vue&type=script&lang=js"
export * from "./TheHallbar.vue?vue&type=script&lang=js"
import style0 from "./TheHallbar.vue?vue&type=style&index=0&id=5a96fcec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96fcec",
  null
  
)

export default component.exports